import { Component, Input, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Slides, AlertController, ToastController, ModalController, ViewController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';

/**
 * Generated class for the AccountconfirmPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-accountconfirm',
  templateUrl: 'accountconfirm.html',
})
export class AccountconfirmPage {

    texts: any = [];
    language : string;

    id: string;
    email: string;
    terms_site: string;
	password: string;
	confirmPassword: string;
	name: string;
	phone: string = ''; 
	country: string;
	chucheon: string;
	huwon: string;
	branch: string;
	center: string;
    birthday: string;

    public isEnabledBtn: boolean = true;
  
    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private http: HttpService,
        private alertCtrl: AlertController,
        public toastCtrl: ToastController,
		public modalCtrl: ModalController,
		public viewCtrl: ViewController,
		private app: App,
    ) {
        this.id = this.navParams.get('id');
        this.chucheon = this.navParams.get('chucheon');
        this.huwon = this.navParams.get('huwon');
        this.name = this.navParams.get('name');
        this.birthday = this.navParams.get('birthday');
        this.email = this.navParams.get('email');
        this.phone = this.navParams.get('phone');
        this.country = this.navParams.get('country');
        this.branch = this.navParams.get('branch');
        this.center = this.navParams.get('center');
    }

    ionViewWillEnter() {

        //// 로그인 정보를 지운다.
        //// 새로 가입하여 완료되면 자동 로그인이 된다.
        // localStorage.removeItem("loginId");
        this.language = localStorage.getItem("language");
		this.texts = JSON.parse(localStorage.getItem("texts"));

        localStorage.setItem("pageName", "accountconfirm");

        this._get_texts();

    }

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).accountconfirm;
    }   

    _register() {
        this.viewCtrl.dismiss('ok');
    }

    _cancel() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/accountconfirm/accountconfirm.ts